export default __webpack_public_path__ + "static/media/2.462f2b14.jpg";